<template>
  <div id="topBar" class="cursorDefault">
    <div>
      <div class="title">综合智能安全监测平台</div>
      <div class="left">
        <div class="item3">{{ date }}</div>
        <div class="item4">{{ week }}</div>
      </div>
      <div class="right">
        <div class="item1 cursorPointer">
          <img
            @click="fhClick"
            :src="require('@/assets/image/topBar/fh.png')"
            alt=""
            srcset=""
          />
        </div>
        <div class="item2 cursorPointer">
          <img
            @click="syClick"
            :src="require('@/assets/image/topBar/sy.png')"
            alt=""
            srcset=""
          />
        </div>
        <div class="item3">{{ time }}</div>
        <div class="item4">
          <img :src="weatherimg" alt="" srcset="" />
        </div>
        <div class="item5">{{ weather }}</div>
        <div class="item6">{{ temp }}°C</div>
        <el-popover
          class="item8"
          placement="bottom-end"
          popper-class="topBar-popover"
        >
          <div slot="reference" class="cursorPointer">
            <div style="white-space: nowrap; display: flex">
              <div class="item7">
                <img
                  :src="
                    userShow
                      ? require('@/assets/image/topBar/user.png')
                      : require('@/assets/image/topBar/user2.png')
                  "
                  alt=""
                  srcset=""
                />
              </div>
              {{ username }}
            </div>
          </div>
          <div class="user">
            <div class="bj"></div>
            <div class="title">{{ username }}</div>
            <div class="state">当前状态：{{ userShow ? "登录" : "锁定" }}</div>
            <div class="button1" @click="userClick(userShow)">
              {{ userShow ? "修改密码" : "请先登录" }}
            </div>
            <!-- <div class="button2">{{ !userShow ? "登录" : "锁定" }}</div> -->
            <div class="button3" @click="goToAdmin">管理后台</div>
            <div class="button4" @click="logout">退出</div>
          </div>
        </el-popover>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      :append-to-body="true"
      :before-close="before"
      class="userdialog"
    >
      <div class="userdialogbody">
        <div class="bj"></div>
        <div class="title">修改密码</div>
        <div class="password">
          <el-input
            placeholder="请输入原密码"
            v-model="loginForm.password1"
            show-password
          >
            <img
              slot="prefix"
              :src="require('@/assets/image/login/s.png')"
              alt=""
              srcset=""
              class="icon"
            />
          </el-input>
        </div>
        <div class="password">
          <el-input
            placeholder="请输入新密码"
            v-model="loginForm.password2"
            show-password
          >
            <img
              slot="prefix"
              :src="require('@/assets/image/login/s.png')"
              alt=""
              srcset=""
              class="icon"
            />
          </el-input>
        </div>
        <div class="password">
          <el-input
            placeholder="请再次输入新密码"
            v-model="loginForm.password3"
            show-password
          >
            <img
              slot="prefix"
              :src="require('@/assets/image/login/s.png')"
              alt=""
              srcset=""
              class="icon"
            />
          </el-input>
        </div>
        <div @click="resetPwd" class="button">
          <div>确认提交</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getInfo, ResetPwd } from "@/api/user.js";
import { GetWeather } from "@/api/Dashboard.js";
import axios from "axios";
import Cookies from 'js-cookie';

export default {
  name: "topBar",
  data() {
    return {
      username: "纳兰嫣然",
      date: "202X-01-14",
      week: "星期日",
      time: "21:27",
      interval: null,
      dateSync: true,
      userShow: true,
      dialogVisible: false,
      loginForm: {
        password1: "",
        password2: "",
        password3: "",
      },
      timeNumber: 0,
      weatherimg: "",
      weather: "",
      temp: "0",
    };
  },
  mounted() {
    this.getInit();
  },
  deactivated() {
    clearInterval(this.interval);
    this.interval = null;
  },
  methods: {
    fhClick() {
      this.$router.go(-1);
    },
    syClick() {
      this.$router.push("/globe");
    },
    before() {
      this.dialogVisible = false;
    },
    userClick(show) {
      if (show) {
        this.dialogVisible = true;
      }
    },
    getInit() {
      this.getInfo();
      this.getWeather();
      this.interval = setInterval(() => {
        let date = new Date();
        this.getTime(date);
      }, 1000);
    },
    getDate(date) {
      this.date = `${date.getFullYear()}-${
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1
      }-${date.getDate() < 10 ? "0" + date.getDate() : date.getDate()}`;
    },
    resetPwd() {
      if (this.loginForm.password1 == "") {
        this.$message.error("原密码不能为空");
        return;
      } else if (this.loginForm.password2 == "") {
        this.$message.error("新密码不能为空");
        return;
      } else if (this.loginForm.password2 != this.loginForm.password3) {
        this.$message.error("两次密码不一致");
        return;
      }
      ResetPwd({
        oldPwd: this.loginForm.password1,
        newPwd: this.loginForm.password2,
      }).then(() => {
        this.$message({
          message: "密码修改成功",
          type: "success",
        });
        this.dialogVisible = false;
      });
    },
    getWeek(date) {
      let weekList = [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ];
      this.week = weekList[date.getDay()];
    },
    getTime(date) {
      this.time = `${
        date.getHours() < 10 ? "0" + date.getHours() : date.getHours()
      }:${
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()
      }`;
      if (this.dateSync) {
        this.getDate(date);
        this.getWeek(date);
      }
      if (
        (date.getHours() >= 23 && date.getMinutes() >= 59) ||
        (date.getHours() <= 0 && date.getMinutes() <= 1)
      ) {
        this.dateSync = true;
      } else {
        this.dateSync = false;
      }
      this.timeNumber++;
      if (this.timeNumber > 3600) {
        this.timeNumber = 0;
      }
    },
    getWeather() {
      GetWeather().then((res) => {
        if (!res.data) {
          throw new Error('未返回天气数据');
        }

        let data = JSON.parse(JSON.parse(res.data).data);
        this.weather = data.Weather1;
        this.temp = data.CurrentTemp;
        switch (data.Weather1) {
          case "晴":
            this.weatherimg = require("@/assets/image/topBar/qing.png");
            break;
          case "多云":
            this.weatherimg = require("@/assets/image/topBar/duoyun.png");
            break;
          case "小雨":
            this.weatherimg = require("@/assets/image/topBar/xiaoyu.png");
            break;
          case "中雨":
            this.weatherimg = require("@/assets/image/topBar/zhongyu.png");
            break;
          case "大雨":
            this.weatherimg = require("@/assets/image/topBar/dayu.png");
            break;
          case "雪":
            this.weatherimg = require("@/assets/image/topBar/xue.png");
            break;
          case "阴":
            this.weatherimg = require("@/assets/image/topBar/yin.png");
            break;
          case "雨夹雪":
            this.weatherimg = require("@/assets/image/topBar/yuxue.png");
            break;
          default:
            this.weatherimg = require("@/assets/image/topBar/weizhi.png");
            break;
        }
      }).catch(p => {
        this.weatherimg = require("@/assets/image/topBar/weizhi.png");
        this.temp = '--';
        let errormsg;
        if (typeof p == "string") {
          errormsg = p;
        }
        if (p instanceof Error) {
          errormsg = p.message;
        }
        console.warn(errormsg);
      });
    },
    goToAdmin() {
      // 获取本地 token 并设置到 Admin-Token cookie
      const token = Cookies.get('bigScreenToken');
      if (token) {
        Cookies.set('Admin-Token', token, { expires: 7 });
      }
      window.open(window.location.origin + "/admin", "_blank");
    },
    async logout() {
      await this.$store.dispatch("user/logout");
      this.$router.push('/login');
    },
    getInfo() {
      getInfo().then((res) => {
        this.username = res.data.user.name;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#topBar {
  background-image: url("@/assets/image/topBar/bj.png");
  background-size: 100% 100%;
  top: 0;
  height: 90px;
  position: absolute;
  width: 100%;
  color: white;
  z-index: 1000;
  * {
    // font-family: "ysbth";
    font-weight: bold;
  }
  .title {
    font-size: 34px;
    text-align: center;
    margin-top: 5px;
    letter-spacing: 2px;
    font-weight: 700;
    background: linear-gradient(to top, #198dad, #ffff, #ffff);
    -webkit-background-clip: text;
    color: transparent;
    font-family: "Franklin Gothic Medium", "Arial Narrow", Arial, sans-serif;
  }
  .left {
    position: absolute;
    top: 0px;
    left: 0px;
    font-size: 20px;
    width: 100%;
    > div {
      position: absolute;
    }
    > .item1 {
      top: 10px;
      left: 20px;
      > img {
        height: 25px;
      }
    }
    > .item2 {
      top: 10px;
      left: 130px;
    }
    > .item3 {
      top: 34px;
      left: 20%;
    }
    > .item4 {
      top: 44px;
      left: 26%;
    }
  }
  .right {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 100%;
    font-size: 20px;
    > div {
      position: absolute;
    }
    > .item1 {
      top: 52px;
      right: 27%;
      > img {
        height: 22px;
      }
    }
    > .item2 {
      top: 50px;
      right: 22.5%;
      > img {
        height: 22px;
      }
    }
    > .item3 {
      top: 40px;
      right: 18.3%;
      width: 60px;
    }
    > .item4 {
      top: 36px;
      right: 17%;
      > img {
        height: 22px;
      }
    }
    > .item5 {
      text-align: center;
      top: 28px;
      right: 13.5%;
      width: 60px;
    }
    > .item6 {
      top: 24px;
      right: 9.8%;
      width: 70px;
    }
     .item7 {
      top: 16px;
      right: 8.2%;
      > img {
        height: 26px;
      }
      margin-right: 10px;
    }
    .item8 {
      position: absolute;
      top: 12px;
      // right: 3.5%;
      right: 0;
      width: 170px;
    }
    > .item9 {
      top: 10px;
      right: 1%;
    }
  }
}
</style>
<style lang="scss">
.userdialog {
  z-index: 9998 !important;
  .el-dialog__headerbtn{
    right: 30px;
    top:60px;
  }
  .el-dialog {
    background: none;
    background-image: url("@/assets/image/topBar/bk2.png");
    background-size: 100% 100%;
    margin-top: calc(50vh - 250px) !important;
    height: 500px;
    width: 700px;
    position: relative;
  }
  .el-dialog__close {
    font-size: 26px !important;

  }
  .el-dialog__header {
    height: 50px;
  }
  .el-dialog__body {
    padding-left: 60px !important;
    padding-right: 60px !important;
  }

  .bj{
      position: absolute;
      left: 0px;
      top: 33px;
      width: calc(100% - 2px);
      height: calc(100% - 66px);
      background-color: #133890;
      z-index: -1;
    }
  .title {
    font-size: 30px;
    color: white;
    text-align: center;
    margin-top: -20px;
  }
  .password {
    margin-top: 20px;
    margin-right:100px;
    margin-left:80px;
    input {
      height: 60px;
      padding-left: 50px;
      background-color: #0000;
      border-color: rgb(41, 95, 178);
      font-size: 20px;
      letter-spacing: 1.5px;
      color: white;
    }
    .el-input__prefix {
      display: flex;
      align-items: center;
      margin-left: 6px;
    }
    .icon {
      width: 24px;
    }
    .el-input .el-input__clear {
      font-size: 24px;
      margin-right: 10px;
    }
  }
  .button {
    margin-top: 20px;
    height: 50px;
    line-height: 50px;
    color: white;
    font-size: 24px;
    border-radius: 10px;
    border: 1px solid #198dad;
    background-color: #198dad99;
    text-align: center;
    width: 300px;
    margin-left: calc(50% - 150px);
  }
}
.topBar-popover {
  background-color: #aaa0 !important;
  border: none !important;
  .popper__arrow {
    display: none;
  }
  .user {
    background-image: url("@/assets/image/topBar/bk.png");
    background-size: 100% 100%;
    height: 260px;
    width: 240px;
    position: relative;
    padding: 20px;
    .bj{
      position: absolute;
      // left: 10px;
      // top: 10px;
      top:0px;
      left: 0px;
      width: calc(100% - 0px);
      height: calc(100% - 0px);
      background-color: #133890;
      z-index: -1;
    }
    .title,
    .state {
      text-align: center;
      padding-top: 10px;
      font-size: 16px;
      color: white;
    }
    .button1,
    .button2,
    .button3,
    .button4 {
      height: 35px;
      margin-left: 35px;
      margin-right: 35px;
      margin-top: 8px;
      background-image: url("@/assets/image/topBar/userbj.png");
      background-size: 100% 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 15px;
      color: white;
      transition: all 0.3s;
    }
    .button1:hover,
    .button2:hover,
    .button3:hover,
    .button4:hover {
      cursor: pointer;
      background-color: rgba(25, 141, 173, 0.5);
    }
  }
}
</style>
